module.exports = __webpack_public_path__ + "img/sld_transformer_delta_star3.ecf79197.svg";